import { Box, Typography } from "@mui/material";
import { Tree } from "react-arborist";
import FolderIcon from '@mui/icons-material/Folder';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { AuthContext } from "../../contexts/AuthContext";
import { useContext } from "react";
import useSepararNomeETipo from "../../lib/useSepararStrintCochetes";

export default function FileTree({
    data
}: FileTreeProps) {

    return (
        <Box
            p={1}
            border="1px solid #ccc"
            borderRadius={2}
        >
            <Tree
                initialData={data}
                openByDefault={false}
                width="100%"
                height={250}
                indent={24}
                rowHeight={36}
                overscanCount={1}
            >
                {Node}
            </Tree>
        </Box>
    )
}

const Node = ({ node, style, dragHandle }: any) => {

    const { token } = useContext(AuthContext);
    
    const { nome: nomeNode, tipo: tipoNode } = useSepararNomeETipo(node.data.name)

    const nodeArquivo = tipoNode === "Arquivo"

    return (
        <Box
            display="flex"
            gap={1}
            alignItems="center"
            ref={dragHandle}
            onClick={() => node.toggle()}
            onDoubleClick={() => {
                if(!nodeArquivo) return
                const url = `${process.env.REACT_APP_API}/api/baixar-arquivo-copynorte/${node.data.id}?token=${token}`
                window.open(url, "_blank");
            }}
            sx={{
                paddingLeft: style.paddingLeft / 7,
                cursor: nodeArquivo ? "pointer" : "normal"
            }}
        >
            {nodeArquivo ? <InsertDriveFileOutlinedIcon fontSize="small" color="primary" /> : <FolderIcon fontSize="small" color="warning" />}
            <Typography variant="caption">{nomeNode}</Typography>
        </Box>
    );
}

interface FileTreeProps {
    data: Data[]
}

interface Data {
    id: string;
    name: string;
    children?: Data[];
}